import { render } from "./StoryAd.vue?vue&type=template&id=2db1a120"
import script from "./StoryAd.vue?vue&type=script&lang=js"
export * from "./StoryAd.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__